import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M8.224 8.26c.926-1.069 1.5-3.295.213-4.025-1.568-.89-3.086.753-4.076 1.842-3.271 4.219-2.503 10.291 1.716 13.562 4.22 3.272 10.291 2.503 13.563-1.716 3.271-4.219 2.503-10.291-1.716-13.562C16.093 2.94 14.148 2.282 12 2.336V4M12 19.616v1.354M3 12h1.354M20 12h1.353"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m12.903 12.903.006-.004-.002-.002L16 8l-4.897 3.093-.002-.002-.004.006-.006.004.002.002L8 16l4.897-3.093.002.002z"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const CompassIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
